/* eslint-disable max-len */
export const SettingError: React.FC<React.SVGProps<SVGSVGElement>> = ({ color, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className="stroke-icon"
      {...props}
    >
      <path
        d="M34 30V34M34.018 38H34M44 34C44 39.5228 39.5228 44 34 44C28.4772 44 24 39.5228 24 34C24 28.4772 28.4772 24 34 24C39.5228 24 44 28.4772 44 34Z"
        stroke={color || 'var(--allie-color-error-main)'}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M28.768 18.875C27.5182 17.7116 25.8422 17 24 17C20.134 17 17 20.134 17 24C17 25.8422 17.7116 27.5182 18.875 28.768"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M19.56 40.872C18.6688 39.9808 18.3769 39.7132 17.8115 39.4778C17.243 39.2408 16.6514 39.2322 15.3834 39.2322C12.3676 39.2322 10.6417 39.2322 9.70478 38.2952C8.76788 37.3584 8.76788 35.6324 8.76788 32.6166C8.76788 31.3554 8.75962 30.7634 8.52598 30.1974C8.29146 29.6294 7.8793 29.2044 6.98332 28.3082C5.85518 27.18 4 25.7718 4 24C4 22.228 5.85512 20.8198 6.98332 19.6917C7.87512 18.7999 8.28756 18.376 8.52274 17.8103C8.75902 17.242 8.76788 16.6505 8.76788 15.3834C8.76788 12.3676 8.76788 10.6417 9.70478 9.70478C10.6417 8.76788 12.3676 8.76788 15.3834 8.76788C16.6418 8.76788 17.2332 8.76 17.7986 8.52758C18.3691 8.29304 18.7938 7.88128 19.6917 6.98332C20.8198 5.85512 22.4208 4 24 4C25.5792 4 27.18 5.85518 28.3082 6.98334C29.2058 7.88074 29.631 8.29274 30.2002 8.5271C30.7654 8.75984 31.3574 8.76788 32.6166 8.76788C35.6324 8.76788 37.3584 8.76788 38.2952 9.70478C39.2322 10.6417 39.2322 12.3676 39.2322 15.3834C39.2322 16.6477 39.2404 17.2392 39.4756 17.8064C39.711 18.3739 39.9782 18.6422 40.872 19.536"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
